import React from "react";
import { Box, Chip, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import ImageCarousel from "./imageCarousel";

const TrainingEssentialDetailModal = ({ open, onClose, record }) => {
  if (!record) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <div className="d-flex justify-content-between align-center p-3">
        <Box>
          <h3 style={{ margin: 0 }}>{record.name}</h3>
          {record.brand && (
            <Typography variant="body2" color="text.secondary">{record.brand}</Typography>
          )}
        </Box>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <DialogContent dividers>
        {Array.isArray(record.images) && record.images.length > 0 && (
          <Box sx={{ mb: 2 }}>
            <ImageCarousel images={record.images} alt={record.name || ""} height={200} />
          </Box>
        )}

        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5, flexWrap: "wrap" }}>
          {record.type && <Chip label={record.type} size="small" color="primary" />}
          {Array.isArray(record.tags) &&
            record.tags.map((tag) => <Chip key={tag} label={tag} size="small" variant="outlined" />)}
          {record.price !== undefined && <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>${record.price}</Typography>}
        </Box>

        {record.description && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2">Description</Typography>
            <Typography variant="body2">{record.description}</Typography>
          </Box>
        )}

        {Array.isArray(record.points) && record.points.length > 0 && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 0.5 }}>Points</Typography>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {record.points.map((point, index) => (
                <li key={index}><Typography variant="body2">{point}</Typography></li>
              ))}
            </ul>
          </Box>
        )}

        {record.otherComments && (
          <Box>
            <Typography variant="subtitle2">Other Comments</Typography>
            <Typography variant="body2">{record.otherComments}</Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default TrainingEssentialDetailModal;